import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";
import PillAvailability from "../../shared/helpers/PillAvailability";

export default function DefaultAvailabilityRequestCard(props) {


  return (
    <div className="flex flex-col">
      <div
        className={`h-16 rounded-xl flex flex-col justify-center px-4 py-2.5 shadow relative ${
          props.availability ?
            props.availability === "All Day"
              ? "bg-green-200"
              : props.availability === "Unavailable"
              ? "bg-red-200"
              : props.availability === "No Availability Set"
              ? "bg-slate-100"
              : "bg-amber-200" :
            "bg-slate-100"
        }`}
      >

        <div>
          <h3 className="text-xs font-bold">
            {props.availability ? props.availability : "No Availability Set"}
          </h3>
          {props.availability2 && (
            <h3 className="text-xs mt-1 font-bold">{props.availability2}</h3>
          )}
          {props.preferences &&
            <h4 className="text-xxs text-slate-700">
              {"Preferred: " + props.preferences}
            </h4>
          }
        </div>
      </div>
    </div>
  );
}
